import C from 'utils/values/constant.util';

const QUICK_BEAUTY = C({
  name: 'Quick Start Salon',
  pricing_type: 'role',
  phone: '12414212',
  postcode: 'WESADAWDA',
  roles: ['Therapist'],

  categories: [
    { name: 'Nails', color: '#c93b7e' },
    { name: 'Waxing', color: '#3da49d' },
    { name: 'Lashes / Brows', color: '#7300af' },
    { name: 'Facials', color: '#5e72d1' },
    { name: 'Skin Test / Consultation', color: '#9b9b9b' },
    { name: 'Staff Training', color: '#3da49d' },
  ],

  services: [
    {
      category: 'Nails',
      name: 'Shellac Manicure',

      duration: '00:45:00',
      price: 45,
      processing: '00:00:00',
      variable_pricing: false,

      by_role: [
        {
          role: 'Therapist',
          duration: '00:45:00',
          price: 30,
          processing: '00:00:00',
        },
      ],
    },
    {
      category: 'Nails',
      name: 'Shellac Pedicure',

      duration: '00:45:00',
      price: 45,
      processing: '00:00:00',
      variable_pricing: false,

      by_role: [
        {
          role: 'Therapist',
          duration: '01:00:00',
          price: 35,
          processing: '00:00:00',
        },
      ],
    },
    {
      category: 'Waxing',
      name: 'Full Leg Wax',

      duration: '00:45:00',
      price: 45,
      processing: '00:00:00',
      variable_pricing: false,

      by_role: [
        {
          role: 'Therapist',
          duration: '01:00:00',
          price: 45,
          processing: '00:00:00',
        },
      ],
    },
    {
      category: 'Waxing',
      name: 'Brazilian Wax',

      duration: '00:45:00',
      price: 45,
      processing: '00:00:00',
      variable_pricing: false,

      by_role: [
        {
          role: 'Therapist',
          duration: '01:00:00',
          price: 55,
          processing: '00:00:00',
        },
      ],
    },
    {
      category: 'Lashes / Brows',
      name: 'Full Set Lash Extensions',

      duration: '00:45:00',
      price: 45,
      processing: '00:00:00',
      variable_pricing: false,

      by_role: [
        {
          role: 'Therapist',
          duration: '01:30:00',
          price: 70,
          processing: '00:00:00',
        },
      ],
    },
    {
      category: 'Lashes / Brows',
      name: 'Brow Shape & Tint',

      duration: '00:45:00',
      price: 45,
      processing: '00:00:00',
      variable_pricing: false,

      by_role: [
        {
          role: 'Therapist',
          duration: '00:45:00',
          price: 25,
          processing: '00:00:00',
        },
      ],
    },
    {
      category: 'Facials',
      name: 'Anti-Aging Facial',

      duration: '00:45:00',
      price: 45,
      processing: '00:00:00',
      variable_pricing: false,

      by_role: [
        {
          role: 'Therapist',
          duration: '01:00:00',
          price: 90,
          processing: '00:00:00',
        },
      ],
    },
    {
      category: 'Facials',
      name: 'Hydrating Facial',

      duration: '00:45:00',
      price: 45,
      processing: '00:00:00',
      variable_pricing: false,

      by_role: [
        {
          role: 'Therapist',
          duration: '01:00:00',
          price: 80,
          processing: '00:00:00',
        },
      ],
    },
    {
      category: 'Skin Test / Consultation',
      name: 'Patch Test',

      duration: '00:45:00',
      price: 45,
      processing: '00:00:00',
      variable_pricing: false,

      by_role: [
        {
          role: 'Therapist',
          duration: '00:15:00',
          price: 0,
          processing: '00:00:00',
        },
      ],
    },
    {
      category: 'Staff Training',
      name: 'Evening Training Course',

      duration: '00:45:00',
      price: 45,
      processing: '00:00:00',
      variable_pricing: false,

      by_role: [
        {
          role: 'Therapist',
          duration: '01:00:00',
          price: 0,
          processing: '00:00:00',
        },
      ],
    },
  ],
  stylists: [
    {
      user_name: 'Example Therapist',
      gender: 'male',
      status: 'active',
      role: 'Therapist',
      categories: ['Nails', 'Waxing', 'Lashes / Brows', 'Facials', 'Skin Test / Consultation', 'Staff Training'],
      services: [
        {
          category: 'Nails',
          name: 'Shellac Manicure',
        },
        {
          category: 'Nails',
          name: 'Shellac Pedicure',
        },
        {
          category: 'Waxing',
          name: 'Full Leg Wax',
        },
        {
          category: 'Waxing',
          name: 'Brazilian Wax',
        },
        {
          category: 'Lashes / Brows',
          name: 'Full Set Lash Extensions',
        },
        {
          category: 'Lashes / Brows',
          name: 'Brow Shape & Tint',
        },
        {
          category: 'Facials',
          name: 'Anti-Aging Facial',
        },
        {
          category: 'Facials',
          name: 'Hydrating Facial',
        },
        {
          category: 'Skin Test / Consultation',
          name: 'Patch Test',
        },
        {
          category: 'Staff Training',
          name: 'Evening Training Course',
        },
      ],
    },
  ],
  clients: [
    { user_name: 'Pia Jackson', email: 'info@getslick.com', notes: '' },
    { user_name: 'Jess Smith', email: 'info@getslick.com', notes: 'Length 12s and 13s, curl mix of Bs and Cs' },
    { user_name: 'Amy Harrison', email: 'info@getslick.com', notes: '' },
    { user_name: 'Katie Jones', email: 'info@getslick.com', notes: '' },
    { user_name: 'Mandy Lane', email: 'info@getslick.com', notes: 'Paid £10 deposit' },
    { user_name: 'Lucy', email: 'info@getslick.com', notes: '' },
    { user_name: 'Example Therapist', email: 'info@getslick.com', notes: '' },
    { user_name: 'Sophia', email: 'info@getslick.com', notes: '' },
    { user_name: 'Bee Ford', email: 'info@getslick.com', notes: '' },
    { user_name: 'Jenny Woods', email: 'info@getslick.com', notes: 'Regular client, no deposit taken' },
    { user_name: 'Lily Adams', email: 'info@getslick.com', notes: '' },
    { user_name: 'Charlotte Smith', email: 'info@getslick.com', notes: '' },
    {
      user_name: 'Alisone Wonderland',
      email: 'info@getslick.com',
      notes: 'Paid £10 deposit',
    },
    {
      user_name: 'Sandra Wilson',
      email: 'info@getslick.com',
      notes: 'Sometimes cancels via text but usually rebooks online',
    },
  ],
  appointments: [
    {
      start_hour: '11:00',

      client_name: 'Pia Jackson',
      status: 'paid',
      procedures: [
        {
          duration_minutes: '45',

          service: {
            category: 'Nails',
            name: 'Shellac Manicure',
          },
          stylist_name: 'Lucy',
          start_time: '',
        },
      ],
    },
    {
      start_hour: '13:00',

      client_name: 'Jess Smith',
      status: 'confirmed',
      procedures: [
        {
          duration_minutes: '90',

          service: {
            category: 'Lashes / Brows',
            name: 'Full Set Lash Extensions',
          },
          stylist_name: 'Lucy',
          start_time: '',
        },
      ],
    },
    {
      start_hour: '15:15',

      client_name: 'Amy Harrison',
      status: 'confirmed',
      procedures: [
        {
          duration_minutes: '45',

          service: {
            category: 'Waxing',
            name: 'Full Leg Wax',
          },
          stylist_name: 'Lucy',
          start_time: '',
        },
        {
          duration_minutes: '60',

          service: {
            category: 'Nails',
            name: 'Shellac Pedicure',
          },
          stylist_name: 'Example Therapist',
          start_time: '',
        },
      ],
    },
    {
      start_hour: '17:45',

      client_name: 'Katie Jones',
      status: 'confirmed',
      procedures: [
        {
          duration_minutes: '45',

          service: {
            category: 'Lashes / Brows',
            name: 'Brow Shape & Tint',
          },
          stylist_name: 'Lucy',
          start_time: '',
        },
      ],
    },
    {
      start_hour: '19:30',

      client_name: 'Mandy Lane',
      status: 'confirmed',
      procedures: [
        {
          duration_minutes: '60',

          service: {
            category: 'Facials',
            name: 'Anti-Aging Facial',
          },
          stylist_name: 'Lucy',
          start_time: '',
        },
      ],
    },
    {
      start_hour: '21:00',

      client_name: 'Lucy',
      status: 'confirmed',
      procedures: [
        {
          duration_minutes: '120',

          service: {
            category: 'Staff Training',
            name: 'Evening Training Course',
          },
          stylist_name: 'Lucy',
          start_time: '',
        },
      ],
    },
    {
      start_hour: '21:00',

      client_name: 'Example Therapist',
      status: 'confirmed',
      procedures: [
        {
          duration_minutes: '120',

          service: {
            category: 'Staff Training',
            name: 'Evening Training Course',
          },
          stylist_name: 'Example Therapist',
          start_time: '',
        },
      ],
    },
    {
      start_hour: '21:00',

      client_name: 'Sophia',
      status: 'confirmed',
      procedures: [
        {
          duration_minutes: '120',

          service: {
            category: 'Staff Training',
            name: 'Evening Training Course',
          },
          stylist_name: 'Sophia',
          start_time: '',
        },
      ],
    },
    {
      start_hour: '12:00',

      client_name: 'Bee Ford',
      status: 'paid',
      procedures: [
        {
          duration_minutes: '45',

          service: {
            category: 'Waxing',
            name: 'Full Leg Wax',
          },
          stylist_name: 'Example Therapist',
          start_time: '',
        },
      ],
    },
    {
      start_hour: '14:15',

      client_name: 'Jenny Woods',
      status: 'confirmed',
      procedures: [
        {
          duration_minutes: '60',

          service: {
            category: 'Facials',
            name: 'Hydrating Facial',
          },
          stylist_name: 'Example Therapist',
          start_time: '',
        },
      ],
    },
    {
      start_hour: '18:15',

      client_name: 'Lily Adams',
      status: 'confirmed',
      procedures: [
        {
          duration_minutes: '45',

          service: {
            category: 'Waxing',
            name: 'Brazilian Wax',
          },
          stylist_name: 'Example Therapist',
          start_time: '',
        },
      ],
    },
    {
      start_hour: '20:00',

      client_name: 'Charlotte Smith',
      status: 'confirmed',
      procedures: [
        {
          duration_minutes: '15',

          service: {
            category: 'Skin Test / Consultation',
            name: 'Patch Test',
          },
          stylist_name: 'Example Therapist',
          start_time: '',
        },
      ],
    },
    {
      start_hour: '16:30',

      client_name: 'Alisone Wonderland',
      status: 'confirmed',
      procedures: [
        {
          duration_minutes: '60',

          service: {
            category: 'Facials',
            name: 'Hydrating Facial',
          },
          stylist_name: 'Sophia',
          start_time: '',
        },
      ],
    },
    {
      start_hour: '18:30',

      client_name: 'Sandra Wilson',
      status: 'canceled',
      procedures: [
        {
          duration_minutes: '45',

          service: {
            category: 'Waxing',
            name: 'Full Leg Wax',
          },
          stylist_name: 'Sophia',
          start_time: '',
        },
      ],
    },
    {
      special: '2 days',

      client_name: 'Alisone Wonderland',
      status: 'confirmed',
      procedures: [
        {
          duration_minutes: '60',

          service: {
            category: 'Facials',
            name: 'Hydrating Facial',
          },
          stylist_name: 'Sophia',
          start_time: '',
        },
      ],
    },
  ],
  times_off: [
    {
      start_hour: '11:00',
      duration_minutes: '270',

      stylist_name: 'Sophia',
      start_time: '142121212441',
      end_time: '151124121412',
    },
  ],
});

export default QUICK_BEAUTY;
